module.exports = __webpack_public_path__ + "img/28 duro.717dbb5e.jpg";